import {
  Component,
  NgZone,
  OnDestroy,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Store } from '@softline/core';
import {
  PatchContextStore,
  SOFTLINE_FEATURE_UTILITIES_ACCOUNT,
  SOFTLINE_FEATURE_UTILITIES_PATCH_CONTEXT,
  UtilitiesAccountStore,
} from '@softapps/core/context';
import { distinctUntilKeyChanged, map, observeOn, skip } from 'rxjs/operators';
import { TrueOnlyCheckStrategy } from '@softline/ui-core';
import { asyncScheduler, Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';

export type TicketAccountsContext = { accountid: number; accountids?: number[] };

import { ChipComponent } from '@softline/ui-core';
import { ChipGroupComponent } from '@softline/ui-core';
import { InPipe } from '@softline/ui-core';
import { TranslatePipe } from '@softline/ui-core';
@Component({
  selector: 'lib-account-context-editor',
  imports: [CommonModule, ChipComponent, ChipGroupComponent, InPipe, TranslatePipe],
  templateUrl: './ticket-account-context-editor.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./ticket-account-context-editor.component.css'],
})
export class TicketAccountContextEditorComponent implements OnInit, OnDestroy {
  private subscription?: Subscription;

  checkStrategy = new TrueOnlyCheckStrategy();
  expanded: boolean = false;

  accountIds$ = this.store
    .observe(SOFTLINE_FEATURE_UTILITIES_PATCH_CONTEXT, PatchContextStore.getters.data)
    .pipe(map((o) => (o as TicketAccountsContext).accountids));

  availableAccounts$ = this.store.observe(
    SOFTLINE_FEATURE_UTILITIES_ACCOUNT,
    UtilitiesAccountStore.getters.all
  );

  accountId$ = this.store
    .observe(SOFTLINE_FEATURE_UTILITIES_PATCH_CONTEXT, PatchContextStore.getters.data)
    .pipe(map((o) => (o as TicketAccountsContext).accountid));

  constructor(
    private store: Store,
    private zone: NgZone
  ) {}

  async ngOnInit(): Promise<void> {
    this.subscription = this.store
      .observe(SOFTLINE_FEATURE_UTILITIES_PATCH_CONTEXT, PatchContextStore.getters.data)
      .pipe(
        map((o) => o as TicketAccountsContext),
        distinctUntilKeyChanged('accountid'),
        skip(1),
        observeOn(asyncScheduler)
      )
      .subscribe((o: TicketAccountsContext) => {
        if (o.accountids?.includes(o.accountid)) return;

        console.log('setting account id: ', o.accountid);
        this.store.commit(
          SOFTLINE_FEATURE_UTILITIES_PATCH_CONTEXT,
          PatchContextStore.mutations.patch,
          { accountids: [o.accountid] }
        );
      });
  }
  async ngOnDestroy(): Promise<void> {
    if (this.subscription && !this.subscription.closed) this.subscription.unsubscribe();
    this.subscription = undefined;
  }

  async toggleAccount(accountId: number): Promise<void> {
    this.store.commit(
      SOFTLINE_FEATURE_UTILITIES_PATCH_CONTEXT,
      PatchContextStore.mutations.patch,
      { accountids: [accountId] }
    );
  }

  async selectAll(): Promise<void> {
    const accountids = this.store.get(
      SOFTLINE_FEATURE_UTILITIES_ACCOUNT,
      UtilitiesAccountStore.getters.ids
    );
    this.store.commit(
      SOFTLINE_FEATURE_UTILITIES_PATCH_CONTEXT,
      PatchContextStore.mutations.patch,
      { accountids }
    );
  }

  async selectNone(): Promise<void> {
    const patchedContext = this.store.get(
      SOFTLINE_FEATURE_UTILITIES_PATCH_CONTEXT,
      PatchContextStore.getters.data
    );
    const accountids = [(patchedContext as TicketAccountsContext).accountid];
    this.store.commit(
      SOFTLINE_FEATURE_UTILITIES_PATCH_CONTEXT,
      PatchContextStore.mutations.patch,
      { accountids }
    );
  }
}
